import { Component, DestroyRef, inject, OnInit } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { GlobalActions, GlobalEventDispatcher } from '@ps20-frontend/shop-integration-redux';
import { NgRedux, select } from '@angular-redux3/store';
import { App, FeatureToggles, isTiergruppeActive } from '@ps20-frontend/frontend-models';
import { filter, Observable, take } from 'rxjs';
import { LazyElementDirective } from '@angular-extensions/elements';
import { AsyncPipe } from '@angular/common';
import { IAppState } from '../../store/localStore';
import { loadAppConfig } from '../../store/local.actions';
import { appSourcePathConfigSelectorGenerator } from '../../store/selectors/app.selectors';

export const selectTiergruppeActive = (state: IAppState): boolean =>
  isTiergruppeActive(state.transientState.featureToggles);

export const selectFeatureToggles = (state: IAppState): FeatureToggles | null | undefined =>
  state.transientState.featureToggles;

@Component({
  selector: 'ps20-shop-tgv-angebot',
  templateUrl: './tgv-angebot.component.html',
  imports: [LazyElementDirective, AsyncPipe],
})
export class TgvAngebotComponent implements OnInit {
  globalEventDispatcher: GlobalEventDispatcher = GlobalEventDispatcher.getInstance();

  @select(appSourcePathConfigSelectorGenerator(App.TGV))
  mainFilename$: Observable<string>;

  @select(selectTiergruppeActive)
  tiergruppeActive$: Observable<boolean>;

  @select(selectFeatureToggles)
  featureToggles$: Observable<FeatureToggles | null | undefined>;

  private readonly ngRedux = inject<NgRedux<IAppState>>(NgRedux);
  private readonly destroyRef = inject(DestroyRef);

  ngOnInit(): void {
    this.featureToggles$
      .pipe(
        filter((featureToggles) => featureToggles != null),
        take(1),
        takeUntilDestroyed(this.destroyRef),
      )
      .subscribe((featureToggles) => {
        if (isTiergruppeActive(featureToggles)) {
          this.ngRedux.dispatch(loadAppConfig(App.TGV));
        } else {
          this.globalEventDispatcher.dispatch(
            new GlobalActions().navigationRequested({ appId: App.SHOP_DASHBOARD }),
          );
        }
      });
  }
}
